import React, { useState } from "react";
import { useSelector } from "react-redux";
import PasswordUpdateSection from "./passwordUpdateSection";
import SingleInfoSection from "./singleInfoSection";
import { onlyFirstLetterCapital } from "../../Util/dataHelper";
import ComponentHeader from "../CommonComponents/componentHeader";
import LoadingSpinner from "../CommonComponents/loadingSpinner";
import ProfileUpdateModal from "./profileUpdateModal";
const PROFILE_COMPONENT = "PROFILE_COMPONENT";

const mapping = {
    "contactPerson": "Name",
    "address": "Address",
    "email": "Email",
    "phoneNo": "Phone No.",
    "companyName": "Company Name",
    "contactPersonTitle": "Title",
    "billingAddress": "Billing Address"
}

const ProfilePageWrapper = () => {
    const partnerDetails = useSelector(state => state.partnerDetails);
    const [loading, setLoading] = useState(false);
    const [selectedProfileInfo, setSelectedProfileInfo] = useState(null);

    if (partnerDetails === null)
        return <></>

    const setInfoForModal = (fieldName) => {
        setSelectedProfileInfo({
            "fieldName": fieldName,
            "displayName": mapping[fieldName],
            "oldValue": partnerDetails?.[fieldName] ?? ""
        })
    }

    return (
        <>
            <ComponentHeader title="Profile" />
            <div className="mx-auto p-2 d-flex justify-content-center profile-container">
                <div className="profile-div">
                    <span className="sub-title">Personal Information</span>
                    <div className="mt-2 mb-3 info-container lh-lg">
                        <SingleInfoSection label={"Name"} info={partnerDetails.contactPerson} showChangeBtn={true} 
                            onChange={() => setInfoForModal("contactPerson")} />
                        <SingleInfoSection label={"Address:"} info={partnerDetails.address ?? "N/A"} showChangeBtn={true} 
                            onChange={() => setInfoForModal("address")} />
                        <SingleInfoSection label={"Email:"} info={partnerDetails.email} />
                        <SingleInfoSection label={"Phone No.:"} info={partnerDetails.phoneNo} />
                    </div>
                    <span className="sub-title mt-4">Business Info</span>
                    <div className="mt-2 mb-3 info-container lh-lg">
                        <SingleInfoSection label={"Company Name:"} info={partnerDetails.companyName ?? "N/A"} showChangeBtn={true} 
                            onChange={() => setInfoForModal("companyName")} />
                        <SingleInfoSection label={"Your Title:"} info={partnerDetails.contactPersonTitle ?? "N/A"} showChangeBtn={true} 
                            onChange={() => setInfoForModal("contactPersonTitle")} />
                        <SingleInfoSection label={"Billing Address:"} info={partnerDetails.billingAddress ?? "N/A"} showChangeBtn={true} 
                            onChange={() => setInfoForModal("billingAddress")} />
                    </div>
                    <span className="sub-title mt-4">Partner Info</span>
                    <div className="info-container mt-2 lh-lg">
                        <SingleInfoSection label={"Partner Type:"} info={onlyFirstLetterCapital(partnerDetails.partnerType)} />
                    </div>
                    <PasswordUpdateSection setLoading={setLoading} />
                </div>
                {loading && <LoadingSpinner target={'profile-container'} />}
            </div>
            <ProfileUpdateModal fieldName={selectedProfileInfo?.fieldName} displayName={selectedProfileInfo?.displayName} oldValue={selectedProfileInfo?.oldValue} setLoading={setLoading} />
        </>
    )
}

export default ProfilePageWrapper;
export { PROFILE_COMPONENT };
